export enum PhotographerStatusEnum {
  OnTrial = 1,
  Hired = 2,
  Refused = 3,
  Requested = 4,
  Rejected = 5,
  Dismissed = 6,
  Deleted = 7
}
